// @ts-nocheck
import { useState, useEffect } from 'react';
import axios from 'axios'
import { PrimaryColor, SERVER_IP } from '../../variables';
import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ToastContainer, toast } from "react-toastify";
import Typography from '@mui/material/Typography';
import {
  Grid,
  Button,
} from "@material-ui/core";
import { Sidebar } from "../Sidebar";
import { dateFormat, getCurrentUserID, isLoggedUserStaff } from '../../utils';
import { useNavigate } from 'react-router-dom';


export const ProgressiveClaimPage = () => {

  const [loading, setLoading] = useState(false)
  const [claims, setClaims] = useState<any>([]);
  const [pageSize, setPageSize] = useState(5);
  const navigate = useNavigate();

  const isStaff = isLoggedUserStaff()


  const columns: GridColDef[] = [
    {
      field: 'ProgressiveClaimReportID',
      headerName: 'Claim ID',
      renderCell: (row) => row.value || "NA",
      flex: 1,
      width: 100,
    },
    {
      field: 'ReportedDate',
      headerName: 'Report Date',
      flex: 1,
      renderCell: (row) => row.value ? dateFormat(row.value) : "NA"
    },
    {
      field: 'FileURL',
      headerName: 'Claim Report',
      width: 250,
      renderCell: (row) => {
        return (
          <div style={{ display: 'flex' }}>
            <Button onClick={(e) => {
              navigate('/UpdateProgressiveClaim', {
                state: row.row,
              });
            }} color='primary' variant='contained'>View</Button>
            <Button
              color="error"
              size="small"
              variant="contained"
              style={{marginLeft : 20}}
              onClick={() => {
                if (window.confirm("Are You Sure?")) {
                  deleteProgressiveClaim(row.id)
                }
              }}
            >
              Delete
            </Button>
          </div>
        )
      }
    },
  ];

  useEffect(() => {
    getClaims();
  }, []);


  const getClaims = async () => {
    setLoading(true)
    let url = `${SERVER_IP}progressiveClaimReport/getAll?ContactID=${getCurrentUserID()}&Staff=${isStaff}`
    axios
      .get(url).then(async (res) => {
        let temp = res.data;
        setClaims(temp)
      }).catch((err) => {
        console.log(err)
      }).finally(() => setLoading(false))
  }

  const deleteProgressiveClaim = async (id) => {
    setLoading(true)
    axios.delete(`${SERVER_IP}progressiveClaimReport/delete?ProgressiveClaimReportID=${id}`)
        .then((res) => {
          getClaims();
          toast.success("Deleted Successfully...Table Will Refresh in Few Seconds");
        })
        .catch((res) => {
            toast.error("Couldn't Delete!");
        }).finally(() => setLoading(false))
}

  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container spacing={1} style={{ padding: '10px 30px 10px 30px' }}>
          <Grid container spacing={3} style={{ margin: '10px auto', borderRadius: '10px', border: `2px solid ${PrimaryColor}` }}>

            {
              // !!claims.length &&
              <Grid container>
                <Grid item xs={12}>
                  <Typography style={{ backgroundColor: PrimaryColor, color: 'white' }} variant="h6" gutterBottom>
                    Progressive Claims
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <div style={{ height: 'auto', width: '95%', marginBottom: 10, marginLeft: 'auto', marginRight: 'auto' }}>
                    <Box
                      sx={{
                        width: 1,
                        '& .MuiDataGrid-columnHeaders': {
                          backgroundColor: PrimaryColor,
                        },
                      }}
                    >
                      <DataGrid
                        autoHeight
                        getRowId={(row) => row.ProgressiveClaimReportID}
                        rows={claims}
                        columns={columns}
                        pageSize={pageSize}
                        loading={loading}
                        rowsPerPageOptions={[5, 10, 15, claims.length > 100 ? 100 : claims.length]}
                        disableSelectionOnClick
                        onPageSizeChange={(size) => setPageSize(size)}
                      />
                    </Box>
                  </div>
                </Grid>
              </Grid>
            }

            <ToastContainer />
          </Grid>

        </Grid>


      </div>
    </>
  );
};
